import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "utils/useStore";
import ConversationsStore from "../../Stores/ConversationsStore";
import UnfocusedDrawer from "./UnfocusedDrawer";
import FocusedDrawer from "./FocusedDrawer";

const ConversationsDrawer: React.FunctionComponent = observer(() => {
    const store = useStore(ConversationsStore);

    return (
        <Grid container justifyContent="center" sx={{ height: "100%" }}>
            {store.isFocused ? <FocusedDrawer /> : <UnfocusedDrawer />}
        </Grid>
    );
});

export default ConversationsDrawer;
